import { Skeleton } from '@/components/sui/skeleton'

interface PersonCellSkeletonProps {
  size?: 'sm' | 'md'
}

const SIZES = {
  sm: {
    root: 'flex min-w-0 items-center gap-1',
    avatar: 'size-4 shrink-0 rounded-full',
    name: 'h-3 w-full',
  },
  md: {
    root: 'flex items-center gap-2',
    avatar: 'size-6 shrink-0 rounded-full',
    name: 'h-4 w-full',
  },
}

export function PersonCellSkeleton({ size = 'md' }: PersonCellSkeletonProps) {
  const tokens = SIZES[size]

  return (
    <div className={tokens.root}>
      <Skeleton className={tokens.avatar} />
      <Skeleton className={tokens.name} />
    </div>
  )
}
